module.exports = __webpack_public_path__ + "img/General.dbcc9704.svg";